var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D27A2D",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.382 9.02a.813.813 0 0 0-.31-.338.889.889 0 0 0-.456-.128h-1.335a.267.267 0 0 1-.182-.072.236.236 0 0 1-.076-.171V4.184c0-.1-.033-.198-.094-.28a.515.515 0 0 0-.248-.177.572.572 0 0 0-.313-.01.544.544 0 0 0-.266.156L5.65 10.156a.753.753 0 0 0-.124.845.814.814 0 0 0 .31.338.89.89 0 0 0 .455.128h1.335c.069 0 .134.025.183.07a.235.235 0 0 1 .076.172v4.128c0 .1.032.197.093.279a.515.515 0 0 0 .248.177c.058.01.118.01.176 0a.579.579 0 0 0 .403-.175l5.453-6.283a.752.752 0 0 0 .124-.816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.1828980e72e8fa564760375727bd3e65.svg";
export { ForwardRef as ReactComponent };